import Vue from 'vue'
import App from './App'
import router from './router'
// Element UI 按需引入
import {
  Alert,
  Aside,
  Button,
  Checkbox,
  Container,
  Dialog,
  Divider,
  Drawer,
  Form,
  FormItem,
  Header,
  Input,
  Link,
  Main,
  Message,
  Option,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Scrollbar,
  Select,
  Switch,
  TabPane,
  Tabs,
  Tag,
  Tooltip,
  Upload
} from 'element-ui';
import ElementLoading from 'element-ui/lib/loading';
import ElementMessageBox from 'element-ui/lib/message-box';
import 'element-ui/lib/theme-chalk/loading.css';
import './assets/style/im.scss';
import './assets/iconfont/iconfont.css';
import { createPinia, PiniaVuePlugin } from 'pinia'
import httpRequest from './api/httpRequest';
import * as socketApi from './api/wssocket';
import * as messageType from './api/messageType';
import * as messageUtil from './api/messageUtil';
import emotion from './api/emotion.js';
import url from './api/url.js';
import str from './api/str.js';
import element from './api/element.js';
import * as  enums from './api/enums.js';
import * as dict from './api/dict.js';
import * as  date from './api/date.js';
import permission from './api/permission.js';
import tenantEndpoint from './api/tenantEndpoint.js';
import desktopUpdater from './api/desktopUpdater.js';
import assetResolver from './api/assetResolver';
import nextSnowflakeId from './api/snowflake.js';
import './utils/directive/dialogDrag';
import permissionDirective from './utils/directive/permission';
import useChatStore from './store/chatStore.js'
import useFriendStore from './store/friendStore.js'
import useFriendGroupStore from './store/friendGroupStore.js'
import useGroupStore from './store/groupStore.js'
import useUserStore from './store/userStore.js'
import useConfigStore from './store/configStore.js'
import { initDB } from './db/index.js';
import EmptyState from './components/common/EmptyState.vue';
import { installAppConsoleBridge } from './utils/appLogger';

installAppConsoleBridge();


Vue.use(PiniaVuePlugin)
const pinia = createPinia()
// Element UI 按需注册组件
Vue.use(Alert);
Vue.use(Aside);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Container);
Vue.use(Dialog);
Vue.use(Divider);
Vue.use(Drawer);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Header);
Vue.use(Input);
Vue.use(Link);
Vue.use(ElementLoading.directive);
Vue.use(Main);
Vue.use(Option);
Vue.use(Popover);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Row);
Vue.use(Scrollbar);
Vue.use(Select);
Vue.use(Switch);
Vue.use(TabPane);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Tooltip);
Vue.use(Upload);
Vue.component('empty-state', EmptyState);
// Element UI 挂载全局方法
Vue.prototype.$loading = ElementLoading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = ElementMessageBox;
Vue.prototype.$alert = ElementMessageBox.alert;
Vue.prototype.$confirm = ElementMessageBox.confirm;
Vue.prototype.$prompt = ElementMessageBox.prompt;
// 注册权限指令
Vue.directive('permission', permissionDirective);
// 挂载全局
Vue.prototype.$wsApi = socketApi;
Vue.prototype.$msgType = messageType;
Vue.prototype.$msgUtil = messageUtil;
Vue.prototype.$date = date;
Vue.prototype.$nextSnowflakeId = nextSnowflakeId
Vue.prototype.$http = httpRequest // http请求方法
Vue.prototype.$emo = emotion; // emo表情
Vue.prototype.$url = url; // url转换
Vue.prototype.$str = str; // 字符串相关
Vue.prototype.$elm = element; // 元素操作
Vue.prototype.$enums = enums; // 枚举
Vue.prototype.$dict = dict; // 字典
Vue.prototype.$permission = permission; // 权限检查工具
Vue.prototype.$eventBus = new Vue(); // 全局事件
Vue.prototype.$tenantEndpoint = tenantEndpoint; // 租户发现与线路管理
Vue.prototype.$desktopUpdater = desktopUpdater; // Electron 版本更新编排
Vue.prototype.$assetResolver = assetResolver; // 受保护资源本地还原
Vue.prototype.$eventBus.$on('exit', () => {
  assetResolver.clear();
});
Vue.config.productionTip = false;

function initializeAppContext() {
  Vue.prototype.chatStore = useChatStore(pinia);
  Vue.prototype.friendStore = useFriendStore(pinia);
  Vue.prototype.friendGroupStore = useFriendGroupStore(pinia);
  Vue.prototype.groupStore = useGroupStore(pinia);
  Vue.prototype.userStore = useUserStore(pinia);

  const configStore = useConfigStore(pinia);
  Vue.prototype.configStore = configStore;
  configStore.setElectronMode(Boolean(window.electronAPI));
  configStore.initTheme();
  configStore.initResponsive();

  Vue.prototype.$desktopUpdater.init({
    electronAPI: window.electronAPI,
    configStore
  });
}

function mountApp() {
  initializeAppContext();
  const app = new Vue({
    el: '#app',
    // 配置路由
    router,
    pinia,
    render: h => h(App)
  })

  // 暴露app实例供测试使用
  window.app = app;
}

initDB().then((db) => {
  Vue.prototype.$db = db;
  mountApp();
})
